import { Container, Stack } from "basis";
import { CreditCard } from "components/CreditCard/CreditCard";
import { Layout } from "components/Layout/Layout";
import { Location } from "history";
import { useLocation } from "react-router-dom";
import { LostStolenOrDamaged } from "./LostStolenOrDamaged";
import { LocationState } from "./types";

export const LostStolenOrDamagedPage = () => {
  const { state: locationState } = useLocation() as Location<LocationState>;

  return (
    <Layout>
      <Layout.Header>Report lost, stolen or damaged card</Layout.Header>
      <Layout.Main>
        <Stack gap="8">
          <Container bg="grey.t05" padding="4">
            <CreditCard
              cardName={locationState.product.name}
              cardEndsWith={
                locationState.account.credit_card?.linked_card_last4
              }
            />
          </Container>
          <LostStolenOrDamaged />
        </Stack>
      </Layout.Main>
    </Layout>
  );
};
